export default function getURLFromElem(elem) {
  const src = elem.dataset.src || elem.src

  // The second argument (the base) is necessary to prevent barfing
  // when we encounter an incomplete URL such as '//foo.com'
  return new URL(src, window.location)
}
